export const USER_COOKIES = {
    DISCORD_STATE: "discord-state",
    DISCORD_TOKEN: "discord-token",
    LM_JWT: "lm-session",
};
